import React, { useEffect } from "react";
import { Moon, Sun } from 'lucide-react';
import { useDarkMode } from '../components/DarkModeContext.js';

const NavBar = ({ page }) => {
    const { darkMode, toggleDarkMode, loadCorrectTheme } = useDarkMode();

    useEffect(() => {
        loadCorrectTheme(true, null);
    }, []);

    return (
        <nav className="flex items-center justify-between px-4 py-2 border-b-2 border-black dark:border-white bg-white dark:bg-gray-800 grid grid-cols-3 fixed w-full z-50">
            <div className="text-xl font-bold text-black dark:text-white justify-self-start flex items-center">
                <img src={darkMode ? "/LogoLight.png" : "/LogoDark.png"} alt="logo" className="h-10" />
            </div>
            <div className="text-xl font-bold text-black dark:text-white justify-self-center" onClick={() => window.location.reload()}>
                {page}
            </div>
            <div className="relative justify-self-end text-black dark:text-white text-[2vw] md:text-base">
                <button
                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 hover:rounded-md"
                    onClick={() => toggleDarkMode(false, null)}
                >
                    {
                        page === "MANTEGO" ? (
                            darkMode ? (
                                <>
                                    <Sun size={20} className="text-yellow-500" /> Modalità Chiara
                                </>
                            ) : (
                                <>
                                    <Moon size={20} className="text-blue-900" /> Modalità Scura
                                </>
                            )
                        ) : null
                    }
                </button>
            </div>
        </nav>
    );
};

export default NavBar;
